/**
 * Helpers de bloqueio de contato no frontend.
 * Parceiro RUIM ou flag contactBlocked no lead → sem WhatsApp/e-mail/agente.
 */
export function isBadLawyerPartner(partner) {
  return (partner?.classificacao || '').toUpperCase() === 'RUIM';
}

export function isLeadContactBlocked(contactOrLead, matchedPartner = null) {
  if (contactOrLead?.contactBlocked === true) return true;
  if (isBadLawyerPartner(matchedPartner)) return true;
  return false;
}
